/**
 * STICKERMAN PROOF SYSTEM
 * Shared across all sticker designer tools
 * Version: 1.1 - Fixed syntax errors
 */

(function() {
  'use strict';

  // ============================================================================
  // PROOF SYSTEM CSS - Auto-injected
  // ============================================================================
  
  const proofSystemCSS = `
    /* Proof System Styles */
    .proof-system {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    }

    .proof-toggle {
      background: #021d49;
      color: white;
      border: none;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      font-size: 24px;
      cursor: pointer;
      box-shadow: 0 4px 12px rgba(2,29,73,0.3);
      transition: all 0.2s;
      position: relative;
    }

    .proof-toggle:hover {
      background: #03297a;
      transform: scale(1.05);
    }

    .proof-badge {
      position: absolute;
      top: -5px;
      right: -5px;
      background: #ff4444;
      color: white;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      font-size: 12px;
      font-weight: bold;
      display: none;
      align-items: center;
      justify-content: center;
    }

    .proof-tray {
      position: fixed;
      top: 0;
      right: 0;
      width: 400px;
      height: 100vh;
      background: white;
      border-left: 2px solid #e0e0e0;
      transform: translateX(100%);
      transition: transform 0.3s;
      box-shadow: -5px 0 20px rgba(0,0,0,0.1);
      display: flex;
      flex-direction: column;
      z-index: 9998;
    }

    .proof-tray.open {
      transform: translateX(0);
    }

    .proof-header {
      padding: 24px;
      border-bottom: 2px solid #e0e0e0;
      background: #f8f8f8;
    }

    .proof-title {
      margin: 0 0 8px;
      color: #021d49;
      font-size: 18px;
      font-weight: 800;
    }

    .proof-count {
      color: #666;
      font-size: 14px;
      margin-bottom: 16px;
    }

    .proof-controls {
      display: flex;
      gap: 8px;
    }

    .proof-btn {
      padding: 8px 16px;
      border: 1px solid #021d49;
      border-radius: 6px;
      background: white;
      color: #021d49;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
    }

    .proof-btn:hover {
      background: #021d49;
      color: white;
    }

    .proof-btn.primary {
      background: #021d49;
      color: white;
    }

    .proof-btn.primary:hover {
      background: #03297a;
    }

    .proof-list {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      min-height: 0;
    }

    .proof-item {
      background: #f8f8f8;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 12px;
      position: relative;
    }

    .proof-item-header {
      display: flex;
      justify-content: space-between;
      align-items: start;
      margin-bottom: 12px;
    }

    .proof-item-name {
      font-weight: 700;
      color: #021d49;
      font-size: 14px;
    }

    .proof-item-remove {
      background: none;
      border: none;
      color: #999;
      cursor: pointer;
      font-size: 18px;
      padding: 0;
    }

    .proof-item-remove:hover {
      color: #ff4444;
    }

    .proof-item-specs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      font-size: 12px;
    }

    .spec-label {
      color: #666;
      font-weight: 600;
    }

    .spec-value {
      color: #021d49;
    }

    .empty-proof {
      text-align: center;
      color: #999;
      padding: 60px 20px;
      font-size: 14px;
    }

    .proof-footer {
      padding: 16px;
      border-top: 1px solid #e0e0e0;
      background: #f8f8f8;
      flex-shrink: 0;
    }

    .proof-notification {
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%) translateY(-100px);
      background: #22c55e;
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      font-weight: 600;
      transition: transform 0.3s;
      z-index: 10000;
    }

    .proof-notification.show {
      transform: translateX(-50%) translateY(0);
    }

   /* ADD TO PROOF BUTTON - MATCHES YOUR DESIGN SYSTEM */
.add-to-proof-btn {
  padding: 16px 28px;
  border: 2px solid #021d49;
  border-radius: 8px;
  background: #021d49;
  color: white;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  transition: background 0.2s, transform 0.1s;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.add-to-proof-btn:hover {
  background: #03297a;
}

.add-to-proof-btn:active {
  transform: scale(0.98);
}

.add-to-proof-btn:focus {
  outline: none;
}

.add-to-proof-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
  `;

  // ============================================================================
  // PROOF SYSTEM STATE
  // ============================================================================
  
  var proofItems = [];
  var proofTrayOpen = false;

  // ============================================================================
  // STORAGE FUNCTIONS
  // ============================================================================
  
  function saveProofItems() {
    try {
      localStorage.setItem('stickerProofItems', JSON.stringify(proofItems));
    } catch (e) {
      console.error('Could not save proof items:', e);
    }
  }

  function loadProofItems() {
    try {
      var stored = localStorage.getItem('stickerProofItems');
      if (stored) {
        proofItems = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Could not load proof items:', e);
      proofItems = [];
    }
  }

  function clearProofStorage() {
    try {
      localStorage.removeItem('stickerProofItems');
    } catch (e) {
      console.error('Could not clear proof storage:', e);
    }
  }

  // ============================================================================
  // PROOF ITEM FUNCTIONS
  // ============================================================================
  
  function addToProof(designData) {
    if (!designData) {
      console.error('No design data provided');
      return false;
    }

    // Add timestamp if not present
    if (!designData.timestamp) {
      designData.timestamp = new Date().toISOString();
    }

    // Add unique ID if not present
    if (!designData.id) {
      designData.id = Date.now();
    }

    proofItems.push(designData);
    saveProofItems();
    updateProofDisplay();
    showNotification();
    
    // Auto-open tray on first addition
    if (!proofTrayOpen) {
      toggleProofTray();
    }

    return true;
  }

  function removeProofItem(id) {
    proofItems = proofItems.filter(function(item) { return item.id !== id; });
    saveProofItems();
    updateProofDisplay();
  }

  function clearAllProofs() {
    if (confirm('Clear all designs from proof sheet?')) {
      proofItems = [];
      saveProofItems();
      updateProofDisplay();
    }
  }

  // ============================================================================
  // DISPLAY FUNCTIONS
  // ============================================================================
  
  function updateProofDisplay() {
    var count = proofItems.length;
    
    // Update badge
    var badge = document.getElementById('proof-badge');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    
    // Update count text
    var countText = document.getElementById('proof-count-text');
    if (countText) {
      countText.textContent = count + ' design' + (count !== 1 ? 's' : '');
    }
    
    // Update list
    var list = document.getElementById('proof-list');
    if (!list) return;
    
    if (count === 0) {
      list.innerHTML = '<div class="empty-proof">No designs added yet.<br>Create designs and click "Add to Proof" to collect them for client approval.</div>';
    } else {
      list.innerHTML = proofItems.map(function(item, index) {
        return '<div class="proof-item">' +
          '<div class="proof-item-header">' +
            '<div class="proof-item-name">Design ' + (index + 1) + '</div>' +
            '<button class="proof-item-remove" onclick="ProofSystem.removeProofItem(' + item.id + ')">×</button>' +
          '</div>' +
          '<div style="margin-bottom: 12px;">' +
            '<img src="' + item.previewImage + '" style="width: 80px; height: 60px; object-fit: contain; border-radius: 4px; border: 1px solid #e0e0e0;">' +
          '</div>' +
          '<div class="proof-item-specs">' +
            '<div><div class="spec-label">Type</div><div class="spec-value">' + (item.shape ? item.shape.charAt(0).toUpperCase() + item.shape.slice(1) : 'N/A') + '</div></div>' +
            '<div><div class="spec-label">Cut</div><div class="spec-value">' + (item.cutType ? item.cutType.charAt(0).toUpperCase() + item.cutType.slice(1) + ' Cut' : 'N/A') + '</div></div>' +
            '<div><div class="spec-label">Size</div><div class="spec-value">' + 
              (item.dimensions ? formatDimensions(item) : 'N/A') +
            '</div></div>' +
            '<div><div class="spec-label">Added</div><div class="spec-value">' + 
              new Date(item.timestamp).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' }) + 
            '</div></div>' +
          '</div>' +
          '<div style="margin-top: 8px; font-size: 11px; color: #666;">' + (item.description || generateDescription(item)) + '</div>' +
        '</div>';
      }).join('');
    }
  }

  function formatDimensions(design) {
    if (!design.dimensions) return 'N/A';
    
    if (design.shape === 'circle') {
      return design.dimensions.diameter + 'mm ⌀';
    } else if (design.shape && design.shape.includes('square')) {
      return design.dimensions.width + 'mm²';
    } else {
      return design.dimensions.width + '×' + design.dimensions.height + 'mm';
    }
  }

  function generateDescription(design) {
    var desc = '';
    
    if (design.shape === 'circle') {
      desc = (design.dimensions ? design.dimensions.diameter : '?') + 'mm Circle Sticker';
    } else if (design.shape === 'square') {
      desc = (design.dimensions ? design.dimensions.width : '?') + 'mm Square Sticker';
    } else if (design.shape === 'rounded-square') {
      desc = (design.dimensions ? design.dimensions.width : '?') + 'mm Rounded Square';
      if (design.dimensions && design.dimensions.cornerRadius) {
        desc += ' (' + design.dimensions.cornerRadius + 'mm corners)';
      }
    } else if (design.shape === 'rect') {
      desc = (design.dimensions ? design.dimensions.width + 'mm × ' + design.dimensions.height + 'mm' : '?') + ' Rectangle';
    } else if (design.shape === 'rounded-rect') {
      desc = (design.dimensions ? design.dimensions.width + 'mm × ' + design.dimensions.height + 'mm' : '?') + ' Rounded Rectangle';
      if (design.dimensions && design.dimensions.cornerRadius) {
        desc += ' (' + design.dimensions.cornerRadius + 'mm corners)';
      }
    } else {
      desc = (design.dimensions ? design.dimensions.width + 'mm × ' + design.dimensions.height + 'mm' : '?') + ' Custom Shape';
    }
    
    var cutTypeText = design.cutType === 'kiss' ? 'Kiss Cut' : 'Die Cut';
    return desc + ' - ' + cutTypeText;
  }

  function showNotification() {
    var notification = document.getElementById('proof-notification');
    if (notification) {
      notification.classList.add('show');
      setTimeout(function() {
        notification.classList.remove('show');
      }, 3000);
    }
  }

  function toggleProofTray() {
    proofTrayOpen = !proofTrayOpen;
    var tray = document.getElementById('proof-tray');
    if (tray) {
      tray.classList.toggle('open', proofTrayOpen);
    }
  }

  // ============================================================================
  // PDF GENERATION
  // ============================================================================
  
  function generateClientProof() {
    if (proofItems.length === 0) {
      alert('Add some designs to the proof first!');
      return;
    }

    var button = document.querySelector('.proof-btn.primary');
    var originalText = button ? button.textContent : '';
    if (button) {
      button.textContent = 'Generating PDF...';
      button.disabled = true;
    }

    try {
      // Check if jsPDF is available
      if (!window.jspdf || !window.jspdf.jsPDF) {
        throw new Error('PDF library not loaded');
      }

      const { jsPDF } = window.jspdf;
      const doc = new jsPDF('p', 'mm', 'a4');
      
      // Page 1: Cover page
      doc.setFontSize(20);
      doc.text('STICKER PROOF SHEET', 20, 30);
      
      doc.setFontSize(12);
      doc.text('Client: Customer Name', 20, 50);
      doc.text('Generated: ' + new Date().toLocaleDateString('en-AU'), 20, 60);
      doc.text('Total Designs: ' + proofItems.length, 20, 70);
      
      doc.setFontSize(14);
      doc.text('APPROVAL INSTRUCTIONS', 20, 90);
      
      doc.setFontSize(10);
      doc.text('• APPROVED - Proceed to print', 30, 105);
      doc.text('• CHANGES REQUIRED - Specify changes', 30, 115);
      doc.text('• REJECTED - Complete revision needed', 30, 125);
      
      // Add design pages
      proofItems.forEach(function(design, index) {
        doc.addPage();
        
        doc.setFontSize(16);
        doc.text('Design ' + (index + 1), 20, 30);
        
        doc.setFontSize(11);
        doc.text('Shape: ' + (design.shape || 'N/A'), 20, 50);
        doc.text('Cut Type: ' + (design.cutType || 'N/A'), 20, 60);
        doc.text('Size: ' + formatDimensions(design), 20, 70);
        doc.text('Created: ' + new Date(design.timestamp).toLocaleDateString('en-AU'), 20, 80);
        
        // Add preview image
        if (design.previewImage) {
          try {
            doc.addImage(design.previewImage, 'PNG', 20, 90, 80, 60);
          } catch (imageError) {
            console.warn('Could not add image to PDF:', imageError);
            doc.text('(Preview image not available)', 20, 100);
          }
        }
      });
      
      // Download the PDF
      doc.save('sticker-proof-' + Date.now() + '.pdf');
      
      // Clear proof option
      if (confirm('PDF downloaded! Clear proof sheet for next client?')) {
        proofItems = [];
        saveProofItems();
        updateProofDisplay();
      }
      
    } catch (error) {
      console.error('PDF generation error:', error);
      alert('Could not generate PDF: ' + error.message + '\n\nPlease ensure the PDF library is loaded.');
    } finally {
      if (button) {
        button.textContent = originalText;
        button.disabled = false;
      }
    }
  }

  // ============================================================================
  // AUTO-INTEGRATION FOR DESIGNER PAGES
  // ============================================================================
  
  function autoDetectDesigner() {
    console.log('Checking if this is a staff designer page...');
    
    // Check if this is a staff designer (SMA- prefix in URL)
    var url = window.location.pathname.toLowerCase();
    var isStaffDesigner = url.includes('sma-') || url.includes('/sma-');
    
    // Also check page title as backup
    if (!isStaffDesigner) {
      var title = document.title.toLowerCase();
      isStaffDesigner = title.includes('sma-');
    }
    
    console.log('URL:', url);
    console.log('Is staff designer (SMA-):', isStaffDesigner);
    
    if (!isStaffDesigner) {
      console.log('Not a staff designer (SMA-) page, skipping proof system');
      return;
    }
    
    console.log('Staff designer detected! Looking for designer elements...');
    
    // Look for common designer elements
    var downloadBtn = document.querySelector('#rsd-download, #download-btn, .download-button, [onclick*="download"]');
    var canvas = document.querySelector('canvas');
    
    console.log('Found download button:', !!downloadBtn);
    console.log('Found canvas:', !!canvas);
    
    // If we find designer elements, inject integration
    if (downloadBtn && canvas) {
      console.log('Injecting proof integration...');
      injectProofIntegration(downloadBtn);
    } else {
      console.log('Designer elements not found');
    }
  }
  
  function injectProofIntegration(downloadBtn) {
    // Check if button already exists
    if (document.querySelector('.add-to-proof-btn')) {
      console.log('Proof button already exists');
      return;
    }
    
    // Create "Add to Proof" button
    var proofBtn = document.createElement('button');
    proofBtn.className = 'add-to-proof-btn';
    proofBtn.innerHTML = '📋 Add to Proof';
    proofBtn.onclick = captureCurrentDesign;
    
    // Insert next to download button
    if (downloadBtn.parentNode) {
      downloadBtn.parentNode.insertBefore(proofBtn, downloadBtn.nextSibling);
      console.log('Proof button injected successfully');
    }
    
    // Style the container to flex if needed
    if (downloadBtn.parentNode) {
      var container = downloadBtn.parentNode;
      container.style.display = 'flex';
      container.style.gap = '12px';
      container.style.alignItems = 'center';
    }
  }
  
  function captureCurrentDesign() {
    try {
      console.log('Capturing current design...');
      
      // Auto-detect canvas
      var canvas = document.querySelector('canvas');
      if (!canvas) {
        alert('Could not find design canvas');
        return;
      }
      
      // Try to capture common design variables
      var designData = {
        id: Date.now(),
        timestamp: new Date().toISOString(),
        previewImage: canvas.toDataURL('image/png'),
        
        // Try to detect common variables (these might be undefined)
        shape: window.shapeType || window.shape || detectShapeFromPage(),
        cutType: window.cutType || window.cut_type || 'kiss',
        dimensions: window.dimensions || window.size || detectDimensionsFromPage(),
        bleedMode: window.bleedMode || window.bleed || 'none'
      };

      // Add fallback values
      if (!designData.shape) designData.shape = 'custom';
      if (!designData.dimensions) designData.dimensions = { width: 50, height: 50 };
      
      console.log('Captured design data:', designData);
      
      // Add to proof
      if (ProofSystem.addToProof(designData)) {
        console.log('Design added to proof successfully');
      }
      
    } catch (error) {
      console.error('Error capturing design:', error);
      alert('Could not capture design. Please try again.');
    }
  }
  
  function detectShapeFromPage() {
    // Try to detect from page title or URL
    var title = document.title.toLowerCase();
    var url = window.location.href.toLowerCase();
    
    if (title.includes('circle') || url.includes('circle')) return 'circle';
    if (title.includes('square') || url.includes('square')) return 'square';  
    if (title.includes('rectangle') || url.includes('rect')) return 'rectangle';
    
    return 'custom';
  }
  
  function detectDimensionsFromPage() {
    // Try to find dimension inputs
    var widthInput = document.querySelector('#width, [name="width"], .width-input');
    var heightInput = document.querySelector('#height, [name="height"], .height-input');
    var diameterInput = document.querySelector('#diameter, [name="diameter"], .diameter-input');
    
    if (diameterInput && diameterInput.value) {
      return { diameter: parseFloat(diameterInput.value) || 50 };
    }
    
    if (widthInput && heightInput) {
      return {
        width: parseFloat(widthInput.value) || 50,
        height: parseFloat(heightInput.value) || 50
      };
    }
    
    return { width: 50, height: 50 };
  }

  // ============================================================================
  // INITIALIZATION
  // ============================================================================
  
  function initProofSystem() {
    console.log('Initializing proof system...');
    
    // Inject CSS
    var style = document.createElement('style');
    style.textContent = proofSystemCSS;
    document.head.appendChild(style);

    // Create HTML structure
    var proofSystemHTML = `
      <div class="proof-system">
        <button class="proof-toggle" id="proof-toggle">
          📋
          <span class="proof-badge" id="proof-badge">0</span>
        </button>
        
        <div class="proof-tray" id="proof-tray">
          <div class="proof-header">
            <h3 class="proof-title">Client Proof Sheet</h3>
            <p class="proof-count"><span id="proof-count-text">0 designs</span> ready for approval</p>
            <div class="proof-controls">
              <button class="proof-btn" onclick="ProofSystem.clearAllProofs()">Clear All</button>
              <button class="proof-btn primary" onclick="ProofSystem.generateClientProof()">Generate PDF Proof</button>
            </div>
          </div>
          
          <div class="proof-list" id="proof-list"></div>

          <div class="proof-footer">
            <button class="proof-btn" onclick="ProofSystem.toggleProofTray()" style="width: 100%;">
              Close Proof Tray
            </button>
          </div>
        </div>

        <div class="proof-notification" id="proof-notification">
          ✓ Design added to proof sheet!
        </div>
      </div>
    `;

    // Append to body
    var container = document.createElement('div');
    container.innerHTML = proofSystemHTML;
    document.body.appendChild(container);

    // Set up event listeners
    var toggleBtn = document.getElementById('proof-toggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', toggleProofTray);
    }

    // Load saved items and display
    loadProofItems();
    updateProofDisplay();
    
    console.log('Proof system initialized');
  }

  // ============================================================================
  // PUBLIC API
  // ============================================================================
  
  window.ProofSystem = {
    // Core functions
    addToProof: addToProof,
    removeProofItem: removeProofItem,
    clearAllProofs: clearAllProofs,
    toggleProofTray: toggleProofTray,
    generateClientProof: generateClientProof,
    
    // Utility functions
    updateProofDisplay: updateProofDisplay,
    loadProofItems: loadProofItems,
    saveProofItems: saveProofItems,
    
    // State access
    getProofItems: function() { return proofItems; },
    getProofCount: function() { return proofItems.length; },
    
    // Initialization
    init: initProofSystem
  };

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProofSystem();
      setTimeout(autoDetectDesigner, 1000); // Give page time to load
    });
  } else {
    initProofSystem();
    setTimeout(autoDetectDesigner, 1000);
  }

})();